export default "__VITE_ASSET__DPzp89qF__"